import React from "react";
import { appData } from "../../landing/data";
import ussdImg from "../../assets/images/home-eight/ussd-img.png"

const DriverUssdSection = () => {
  return (
    <section
      id="driverussd"
    >
      <div className="grid w-full md:grid-cols-6 mx-auto theme-container lg:grid-cols-12">
        <div className="col-span-7 ">
          <img
            src={ussdImg}
            alt=""
            className=""
          />
        </div>
        <div className="flex flex-col justify-center h-full md:col-span-5 mt-5 lg:items-end lg:mt-0">
          <div className="w-full">
            <h2 className="md:text-48 text-24 font-semibold text-main-black mb-[32px] mt-[18px] w-full">
              {appData.whyUs.title}
            </h2>
            <p className="text-paragraph mb-[45px] w-full">
              {appData.whyUs.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DriverUssdSection;
